import React, { Fragment } from 'react';
import HeaderTopbar from '../../components/HeaderTopbar/HeaderTopbar';
import Navbar from '../../components/Navbar/Navbar'
import PageTitle from '../../components/pagetitle/PageTitle'
import Scrollbar from '../../components/scrollbar/scrollbar'
import { useParams } from 'react-router-dom'
import Services from '../../api/Services';
import ServiceSidebar from './sidebar'
import Contact from './contact';
import { Link } from 'react-router-dom'
import simg1 from '../../images/service-single/2.jpg'
import simg2 from '../../images/service-single/3.jpg'
import Footer from '../../components/footer/Footer';
import Logo from '../../images/kihi logo.png'



const ServiceSinglePage = (props) => {
    const { slug } = useParams()

    const serviceDetails = Services.find(item => item.slug === slug)

    

    return (
        <Fragment>

            <Navbar Logo={Logo} hclass={'wpo-site-header wpo-site-header-s3'} />
            <PageTitle pageTitle={serviceDetails.title} pagesub={'Service Single'} />
            
            {/* Hero Section with Modern Design */}
            <div className="wpo-service-single-hero">
                <div className="wpo-service-single-hero container">
                    <div className="row align-items-center">
                        {/* Left Side - Product Images */}
                        <div className="col-lg-5 col-12">
                            <div className="wpo-service-product-showcase">
                                <div className="product-images-container">
                                    {/* Three earthing rods product images */}   
                                    <div className="wpo-p-details-img">
                                        <img src={serviceDetails.image} alt="" />
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Right Side - Content */}
                        <div className="col-lg-7 col-12">
                            <div className="wpo-service-content-modern">
                                <div className="wpo-service-single-title">
                                      <h1>{serviceDetails.title}</h1>
                                </div>
                                
                                <div className="hero-description">
                                    <p className="description-text" >{serviceDetails.description}
                                       
                                    </p>
                                    
                                    {/* <p className="description-text">
                                        As a distinguished manufacturer, supplier, and exporter, we present our top-tier GI Earthing 
                                        Electrodes. Crafted with precision, each electrode showcases exceptional durability, high 
                                        conductivity, and robust corrosion resistance. Serving clients globally, our GI electrodes are the 
                                        embodiment of quality and reliability, ensuring unparalleled protection and performance in 
                                        various applications. Trust U-Protec for advanced earthing solutions that set industry standards.
                                    </p> */}
                                </div>

                                {/* Features Grid */}
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="features-list">
                                            {serviceDetails.leftFeatures.map((feature, index) => (
                                                <div key={index} className="feature-item">
                                                    <div className="feature-icon">
                                                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3">
                                                            <polyline points="20,6 9,17 4,12"></polyline>
                                                        </svg>
                                                    </div>
                                                    <span className="feature-text">
                                                        {feature}
                                                    </span>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                    
                                    <div className="col-md-6">
                                        <div className="features-list">
                                            {serviceDetails.rightFeatures.map((feature, index) => (
                                                <div key={index} className="feature-item">
                                                    <div className="feature-icon">
                                                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3">
                                                            <polyline points="20,6 9,17 4,12"></polyline>
                                                        </svg>
                                                    </div>
                                                    <span className="feature-text">
                                                        {feature}
                                                    </span>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Modern Specifications Section */}
            <div className="wpo-specifications-section">
                <div className="container">
                    <div className="row">
                        {/* Specification Card */}
                        <div className="col-lg-4 col-md-6 col-12 mb-4">
                            <div className="spec-card spec-card-blue">
                                <div className="spec-card-header">
                                    <h3 className="spec-title">Specification</h3>
                                </div>
                                <div className="spec-card-body">
                                    {serviceDetails.specificationsData.specifications.map((spec, index) => (
                                        <div key={index} className="spec-item">
                                            <div className="spec-icon">
                                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                    <polyline points="20,6 9,17 4,12"></polyline>
                                                </svg>
                                            </div>
                                            <span className="spec-text">{spec}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>

                        {/* Application Card */}
                        <div className="col-lg-4 col-md-6 col-12 mb-4">
                            <div className="spec-card spec-card-purple">
                                <div className="spec-card-header">
                                    <h3 className="spec-title">Application</h3>
                                </div>
                                <div className="spec-card-body">
                                    {serviceDetails.specificationsData.applications.map((app, index) => (
                                        <div key={index} className="spec-item">
                                            <div className="spec-icon">
                                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                    <polyline points="20,6 9,17 4,12"></polyline>
                                                </svg>
                                            </div>
                                            <span className="spec-text">{app}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>

                        {/* Advantages Card */}
                        <div className="col-lg-4 col-md-12 col-12 mb-4">
                            <div className="spec-card spec-card-gradient">
                                <div className="spec-card-header">
                                    <h3 className="spec-title">Advantages</h3>
                                </div>
                                <div className="spec-card-body">
                                    {serviceDetails.specificationsData.advantages.map((advantage, index) => (
                                        <div key={index} className="spec-item">
                                            <div className="spec-icon">
                                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                    <polyline points="20,6 9,17 4,12"></polyline>
                                                </svg>
                                            </div>
                                            <span className="spec-text">{advantage}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Rest of the original content */}
            {/* <div className="wpo-service-single-area section-padding">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 col-12">
                            <div className="wpo-service-single-wrap">
                                <div className="wpo-service-single-item">
                                    <div className="wpo-service-single-main-img">
                                        <img src={serviceDetails.simage} alt="eimg" />
                                    </div>
                                    <div className="row mt-4">
                                        <div className="col-md-6 col-sm-6 col-12">
                                            <div className="wpo-p-details-img">
                                                <img src={simg1} alt="" />
                                            </div>
                                        </div>
                                        <div className="col-md-6 col-sm-6 col-12">
                                            <div className="wpo-p-details-img">
                                                <img src={simg2} alt="" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="wpo-service-single-item list-widget">
                                    <div className="wpo-service-single-title">
                                        <h3>Our Capabilities</h3>
                                    </div>
                                    <p>Massa volutpat odio facilisis purus sit elementum. Non, sed velit dictum quam. Id
                                        risus pharetra est, at rhoncus, nec ullamcorper tincidunt. Id aliquet duis
                                        sollicitudin diam.</p>
                                    <ul>
                                        <li>Non saed velit dictum quam risus pharetra esta.</li>
                                        <li>Id risus pharetra est, at rhoncus, nec ullamcorper tincidunt.</li>
                                        <li>Hac nibh fermentum nisi, platea condimentum cursus.</li>
                                        <li>Massa volutpat odio facilisis purus sit elementum.</li>
                                        <li>Elit curabitur amet risus bibendum.</li>
                                    </ul>
                                </div>
                                <div className="wpo-service-single-item">
                                    <div className="wpo-service-single-title">
                                        <h3>Our approach</h3>
                                    </div>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Consequat suspendisse aenean
                                        tellus augue morbi risus. Sit morbi vitae morbi sed urna sed purus. Orci facilisi
                                        eros sed pellentesque. Risus id sed tortor sed scelerisque. Vestibulum elit
                                        elementum, magna id viverra non, velit. Pretium, eros, porttitor fusce auctor vitae
                                        id. Phasellus scelerisque nibh eleifend vel enim mauris purus. Rutrum vel sem
                                        adipiscing nisi vulputate molestie scelerisque molestie ultrices. Eu, fusce
                                        vulputate diam interdum morbi ac a.</p>
                                </div>
                                <div className="wpo-service-single-item list-widget">
                                    <div className="wpo-service-single-title">
                                        <h3>Our Work Process</h3>
                                    </div>
                                    <ul>
                                        <li>Non saed velit dictum quam risus pharetra esta.</li>
                                        <li>Id risus pharetra est, at rhoncus, nec ullamcorper tincidunt.</li>
                                        <li>Hac nibh fermentum nisi, platea condimentum cursus.</li>
                                        <li>Massa volutpat odio facilisis purus sit elementum.</li>
                                    </ul>
                                </div>
                                <div className="wpo-service-single-item">
                                    <div className="wpo-service-single-title">
                                        <h3>Related Service</h3>
                                    </div>
                                    <div className="wpo-service-area">
                                        <div className="row align-items-center">
                                            {Services.slice(0, 2).map((service, index) => (
                                                <div className="col-md-6 col-12" key={index}>
                                                    <div className="service-card" >
                                                        <div className="image">
                                                            <img src={service.image} alt="" />
                                                            <span>{index + 1}</span>
                                                            <div className="line-one"></div>
                                                            <div className="line-two"></div>
                                                        </div>
                                                        <div className="content">
                                                            <div className="icon">
                                                                <img src={service.icon} alt="" />
                                                            </div>
                                                            <h2><Link  to={`/service-single/${service.slug}`}>{service.title}</Link></h2>
                                                            <p>{service.description}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                                <div className="wpo-service-single-item">
                                    <div className="wpo-service-contact-area">
                                        <div className="wpo-contact-title">
                                            <h2>Have project in mind? Let's discuss</h2>
                                            <p>Get in touch with us to see how we can help you with your project</p>
                                        </div>
                                        <div className="wpo-contact-form-area">
                                            <Contact />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div> */}
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};
export default ServiceSinglePage;